import { HomeService } from './home.service';
import { Router } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { SecurityHelper } from '../helpers/security.helper';
import { environment } from 'environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { FeatureToggleService } from './feature-toggle.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { mapResponseWithData } from '../helpers/responseMapper.function';
import { RoleService } from './role.service';
var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router, homeService, securityHelper, httpClient, featureToggleService, roleService) {
        this.router = router;
        this.homeService = homeService;
        this.securityHelper = securityHelper;
        this.httpClient = httpClient;
        this.featureToggleService = featureToggleService;
        this.roleService = roleService;
        this.jwtHelperService = new JwtHelperService();
    }
    AuthGuardService.prototype.hasPermission = function (name) {
        var hasAttribute = false;
        if (this.user.permission) {
            if (Array.isArray(this.user.permission)) {
                hasAttribute = this.user.permission.some(function (permission) { return permission.toLowerCase() == name.toLowerCase(); });
            }
            else {
                hasAttribute = this.user.permission.toLowerCase() == name.toLowerCase();
            }
        }
        return hasAttribute;
    };
    AuthGuardService.prototype.getClaim = function (name) {
        return this.user[name];
    };
    AuthGuardService.prototype.isFeatureEnabled = function (featureName) {
        var userSettingsAsString = localStorage.getItem('userSettings');
        var userSettings = userSettingsAsString && JSON.parse(userSettingsAsString);
        return !!(userSettings && userSettings[featureName]);
    };
    AuthGuardService.prototype.canActivate = function (route, state) {
        var _this = this;
        return new Observable(function (observer) {
            var jwt = localStorage.getItem('tk');
            try {
                _this.user = jwt && _this.jwtHelperService.decodeToken(jwt);
                // If there's no user logged in
                // then navigation is no authorized
                if (!_this.user) {
                    _this.router.navigate(["login"], { queryParams: { returnUrl: state.url } });
                    observer.next(false);
                    observer.complete();
                    return;
                }
                var keys = Object.keys(_this.user);
                var keyName = keys && keys.find(function (k) { return k.includes('name'); });
                _this.user.userName = _this.user[keyName];
                if (_this.user.IsImpersonated === 'true') {
                    observer.next(true);
                    observer.complete();
                    return;
                }
                forkJoin(_this.featureToggleService.getFeaturesByUsername(_this.user.userName), _this.roleService.getAgentHigherRole(_this.user.userName)).subscribe(function () {
                    observer.next(true);
                    observer.complete();
                    return;
                });
            }
            catch (ex) {
                observer.error(ex);
                observer.complete();
            }
        });
    };
    AuthGuardService.prototype.logOut = function () {
        this.user = null;
        var iframeWindowLogs = document.getElementById('polizaLogs');
        this.clearUserStoredData();
        var iframe = iframeWindowLogs && iframeWindowLogs['contentWindow'];
        if (iframe) {
            this.homeService.sendMsg(iframe, { log: 'out' });
        }
        else {
            this.router.navigate(['/login']);
        }
    };
    AuthGuardService.prototype.clearUserStoredData = function () {
        localStorage.removeItem('unsupported-browser-popup');
        localStorage.removeItem('tk');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('hash');
        localStorage.removeItem('userSettings');
        localStorage.removeItem('currentSession');
        localStorage.removeItem('hotjarUserAttributes');
        indexedDB.deleteDatabase('scPolizaDB');
    };
    AuthGuardService.prototype.logOutToOldPortal = function () {
        var iframeWindowLogs = document.getElementById('polizaLogs');
        localStorage.removeItem('tk');
        localStorage.removeItem('userInfo');
        var iframe = iframeWindowLogs && iframeWindowLogs['contentWindow'];
        if (iframe) {
            this.homeService.sendMsg(iframe, { log: 'out' });
        }
        else {
            window.open(environment.server.web.legacy + "PortalSCNet/Productores/Login/Loguin.aspx", "_self");
        }
    };
    AuthGuardService.prototype.isNavigationAuthorized = function (protectedPws) {
        var protectedPwsHash;
        if (protectedPws) {
            protectedPwsHash = this.securityHelper.sha1().sha1(protectedPws);
            localStorage.setItem('protected_hash', protectedPwsHash);
        }
        else {
            protectedPwsHash = localStorage.getItem('protected_hash');
        }
        var pws = localStorage.getItem('hash');
        if (protectedPwsHash && pws) {
            var url = environment.server.api.auth + "/api/protectedData";
            return this.httpClient.post(url, {
                protectedPasswordHash: protectedPwsHash,
                passwordHash: pws,
                showHeader: false
            }).pipe(map(mapResponseWithData));
        }
        else {
            return new Observable(function (observer) {
                observer.next({ isValid: false, legacyToken: null });
                observer.complete();
            });
        }
    };
    AuthGuardService.prototype.getUserInfo = function () {
        return JSON.parse(localStorage.getItem('userInfo'));
    };
    return AuthGuardService;
}());
export { AuthGuardService };
